import React from 'react';
import * as ReactRouterDOM from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { useTranslation } from 'react-i18next';

const { NavLink, Link } = ReactRouterDOM as any;

const HomeIcon = ({ className }: { className?: string }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
  </svg>
);
const DepositIcon = ({ className }: { className?: string }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
  </svg>
);
const OrderIcon = ({ className }: { className?: string }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
  </svg>
);
const UsersIcon = ({ className }: { className?: string }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M15 21v-1a6 6 0 00-1-3.749" />
  </svg>
);
const SettingsIcon = ({ className }: { className?: string }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0 3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
  </svg>
);
const ProductIcon = ({ className }: { className?: string }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
  </svg>
);
const CategoryIcon = ({ className }: { className?: string }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z" />
  </svg>
);
const SupportIcon = ({ className }: { className?: string }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z" />
  </svg>
);
const MediaIcon = ({ className }: { className?: string }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2z" />
  </svg>
);
const ShieldIcon = ({ className }: { className?: string }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 2l7 4v6c0 5-3.5 9-7 10-3.5-1-7-5-7-10V6l7-4z" />
  </svg>
);
const StockIcon = ({ className }: { className?: string }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
  </svg>
);
const CreditCardIcon = ({ className }: { className?: string }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a2 2 0 002-2V9a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
  </svg>
);
const ExternalLinkIcon = ({ className }: { className?: string }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
  </svg>
);
const LogoutIcon = ({ className }: { className?: string }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
  </svg>
);
const TruckIcon = ({ className }: { className?: string }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10l2 2h8a1 1 0 001-1z" />
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h2a1 1 0 001-1V7a1 1 0 00-1-1h-2" />
    <path d="M17 17a2 2 0 11-4 0 2 2 0 014 0z" />
    <path d="M9 17a2 2 0 11-4 0 2 2 0 014 0z" />
  </svg>
);

const AdminSidebar = ({ sidebarOpen, setSidebarOpen }: { sidebarOpen: boolean; setSidebarOpen: (open: boolean) => void }) => {
  const { logout } = useAuth();
  const { t } = useTranslation();

  const navItems = [
    { name: t('admin.nav.dashboard'), path: '/admin', icon: HomeIcon },
    { name: t('admin.nav.deposits'), path: '/admin/deposits', icon: DepositIcon },
    { name: t('admin.nav.orders'), path: '/admin/orders', icon: OrderIcon },
    { name: t('admin.nav.stock'), path: '/admin/stock', icon: StockIcon },
    { name: t('admin.nav.products'), path: '/admin/products', icon: ProductIcon },
    { name: t('admin.nav.categories'), path: '/admin/categories', icon: CategoryIcon },
    { name: t('admin.nav.media'), path: '/admin/media', icon: MediaIcon },
    { name: t('admin.nav.security'), path: '/admin/security', icon: ShieldIcon },
    { name: t('admin.nav.users'), path: '/admin/users', icon: UsersIcon },
    { name: t('admin.nav.tickets'), path: '/admin/support', icon: SupportIcon },
    { name: t('admin.nav.payment_methods'), path: '/admin/payment-methods', icon: CreditCardIcon },
    { name: t('admin.nav.delivery_settings'), path: '/admin/delivery-settings', icon: TruckIcon },
    { name: t('admin.nav.settings'), path: '/admin/settings', icon: SettingsIcon },
  ];

  const linkBase =
    'flex items-center rounded-lg px-3 py-2.5 text-sm font-medium transition-all duration-200 ltr:border-l-2 rtl:border-r-2 rtl:border-l-0 border-transparent';
  const linkActive =
    'border-primary-600 bg-primary-500/10 text-primary-800 shadow-sm ring-1 ring-primary-500/15 dark:border-primary-400 dark:bg-gradient-to-r dark:from-primary-500/25 dark:to-accent-500/15 dark:text-white dark:shadow-sm dark:ring-1 dark:ring-white/10';
  const linkInactive =
    'text-foreground-muted hover:border-primary-500/30 hover:bg-primary-500/[0.06] hover:text-foreground dark:text-slate-400 dark:hover:border-primary-500/40 dark:hover:bg-white/[0.06] dark:hover:text-white';

  return (
    <>
      <div
        className={`fixed inset-0 z-20 bg-slate-900/40 backdrop-blur-[2px] transition-opacity duration-300 dark:bg-slate-950/60 lg:hidden ${sidebarOpen ? 'opacity-100' : 'pointer-events-none opacity-0'}`}
        onClick={() => setSidebarOpen(false)}
        aria-hidden="true"
      />
      <aside
        className={`fixed inset-y-0 z-30 flex w-64 flex-col border-r border-border bg-surface-card text-foreground shadow-xl transition-transform duration-300 ease-out dark:border-white/10 dark:bg-gradient-to-b dark:from-slate-900 dark:via-slate-900 dark:to-primary-950 dark:text-white dark:shadow-2xl dark:shadow-primary-950/40 lg:static lg:translate-x-0 rtl:lg:translate-x-0 left-0 rtl:left-auto rtl:right-0 ${sidebarOpen ? 'translate-x-0' : '-translate-x-full rtl:translate-x-full'}`}
      >
        <div className="h-1 w-full flex-shrink-0 bg-gradient-brand" aria-hidden />

        <div className="flex h-16 flex-shrink-0 items-center justify-center border-b border-border px-3 dark:border-white/10">
          <Link to="/admin" className="text-center text-lg font-bold tracking-tight" onClick={() => setSidebarOpen(false)}>
            <span className="bg-gradient-to-r from-primary-500 to-accent-500 bg-clip-text text-transparent dark:from-primary-300 dark:via-primary-200 dark:to-accent-300">
              e
            </span>
            <span className="text-foreground dark:text-white">Services</span>
            <span className="mt-0.5 block text-[10px] font-semibold uppercase tracking-[0.2em] text-foreground-muted dark:text-slate-500">
              Admin
            </span>
          </Link>
        </div>

        <nav className="admin-scrollbar-thin flex-1 space-y-0.5 overflow-y-auto px-2 py-3" aria-label="Admin">
          {navItems.map((item) => (
            <NavLink
              key={item.name}
              to={item.path}
              end={item.path === '/admin'}
              className={({ isActive }: { isActive: boolean }) =>
                `${linkBase} ${isActive ? linkActive : linkInactive}`
              }
              onClick={() => setSidebarOpen(false)}
            >
              <item.icon className="h-5 w-5 shrink-0 text-primary-600 dark:text-primary-300 ltr:mr-3 rtl:ml-3 rtl:mr-0" />
              <span className="truncate">{item.name}</span>
            </NavLink>
          ))}
        </nav>

        <div className="mt-auto flex-shrink-0 border-t border-border px-2 py-2 dark:border-white/10">
          <NavLink
            to="/"
            className={`${linkBase} ${linkInactive}`}
            onClick={() => setSidebarOpen(false)}
          >
            <ExternalLinkIcon className="h-5 w-5 shrink-0 text-accent-600 opacity-90 dark:text-accent-300 ltr:mr-3 rtl:ml-3 rtl:mr-0" />
            {t('nav.site_home')}
          </NavLink>
        </div>

        <div className="flex-shrink-0 border-t border-border p-3 dark:border-white/10">
          <button
            type="button"
            onClick={logout}
            className="flex w-full items-center rounded-lg px-3 py-2.5 text-sm font-medium text-foreground-muted transition-colors hover:bg-red-500/10 hover:text-red-600 dark:text-slate-400 dark:hover:bg-red-500/15 dark:hover:text-red-300"
          >
            <LogoutIcon className="h-5 w-5 shrink-0 ltr:mr-3 rtl:ml-3 rtl:mr-0" />
            {t('common.logout')}
          </button>
        </div>
      </aside>
    </>
  );
};

export default AdminSidebar;
